import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0 0.911133C0.94 3.19113 2.08002 5.35119 3.58002 7.09119C5.09002 8.82119 7.04999 9.96115 9.20999 9.93115C11.37 10.0012 13.35 8.95116 14.8 7.19116C16.26 5.43116 17.31 3.23114 18.16 0.921143C18.14 3.40114 17.49 5.9311 16.07 8.1311C15.36 9.2411 14.38 10.2212 13.18 10.9312C11.97 11.6212 10.55 11.9512 9.18002 11.9312C7.81002 11.9012 6.41001 11.5312 5.23001 10.8112C4.06001 10.0812 3.09003 9.12114 2.37003 8.04114C0.910026 5.87114 0.16 3.39113 0 0.911133Z"
        fill={outline}
      />
    </g>
  )
}
